import Modal from 'react-bootstrap/Modal';
import { ButtonPrimary, ModalClose } from '../../../common/components';

type SomethingWentWrongModalProps = {
  show: boolean;
  onHide: any;
};

export const SomethingWentWrongModal = (props: SomethingWentWrongModalProps) => {
  return (
    <>
      <Modal animation={false} className={'custom-modal'} show={props.show} backdrop='static' centered>
        <Modal.Header className='pt-0 pb-1 pr-0'>
          <Modal.Title>Something went wrong</Modal.Title>
          <ModalClose
            onClick={() => {
              props.onHide();
            }}
          />
        </Modal.Header>
        <Modal.Body>
          <p className='mb-1'>Unfortunately we can't process your request at this time.</p>
          <p className='mb-0'>Please try again later.</p>
        </Modal.Body>
        <Modal.Footer className='p-0'>
          <ButtonPrimary onClick={() => props.onHide()} className={'mr-0'} title={'Ok'} route='#' />
        </Modal.Footer>
      </Modal>
    </>
  );
};
